var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"id":"map"}}),(_vm.tileSelected != null)?_c('TagMarker',{key:_vm.tileSelected.id,attrs:{"tags":_vm.tileSelected.tags,"tile":_vm.tileSelected.id,"left":_vm.markerLeft,"top":_vm.markerTop},on:{"onTagsSet":_vm.onTagsSet}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }